/**
 * Optional client-side enrichment fallback, used when the empavision backend
 * isn't configured. Produces the same `{ [listingId]: Badge[] }` shape the API
 * returns, so consumers (BadgeStrip / ListingCard) never branch on the source.
 *
 * The badge RULES are marketplace-specific (vehicle mileage, condition, age,
 * etc.), so they intentionally live in the HOST app, not in this shared
 * package. The host injects them via `badgesForListing(listing) => Badge[]`.
 *
 * Each badge: `{ type, display, priority }` (priority: lower = leftmost).
 *
 * Not wired by default — opt in by passing `synthesize` to `useEnrichments`.
 */

export const synthesizeEnrichments = (listings, badgesForListing) => {
  if (typeof badgesForListing !== 'function') {
    return {};
  }

  const result = {};
  (listings || []).forEach(listing => {
    const id = listing?.id?.uuid;
    if (!id) {
      return;
    }
    const badges = badgesForListing(listing) || [];
    if (badges.length > 0) {
      result[id] = badges;
    }
  });
  return result;
};
